import { ReactNode } from 'react'
import {
    InboxIcon,
    MagnifyingGlassIcon,
    ExclamationCircleIcon
} from '@heroicons/react/24/outline'

type EmptyStateVariant = 'no-data' | 'no-results' | 'error'

interface EmptyStateProps {
    variant?: EmptyStateVariant
    title: string
    description?: string
    action?: {
        label: string
        onClick: () => void
    }
    icon?: ReactNode
}

const EmptyState = ({
    variant = 'no-data',
    title,
    description,
    action,
    icon
}: EmptyStateProps) => {
    const defaultIcons: Record<EmptyStateVariant, ReactNode> = {
        'no-data': <InboxIcon className="h-12 w-12 text-gray-400" />,
        'no-results': <MagnifyingGlassIcon className="h-12 w-12 text-gray-400" />,
        'error': <ExclamationCircleIcon className="h-12 w-12 text-red-400" />
    }

    const displayIcon = icon || defaultIcons[variant]

    return (
        <div className="text-center py-12 px-4" role="status" aria-live="polite">
            <div className="flex justify-center mb-4">
                {displayIcon}
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
                {title}
            </h3>
            {description && (
                <p className="text-gray-600 mb-6 max-w-md mx-auto">
                    {description}
                </p>
            )}
            {action && (
                <button
                    onClick={action.onClick}
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                    {action.label}
                </button>
            )}
        </div>
    )
}

export default EmptyState
